/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    questionTaskData : [],
};


const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetTaskAction.GET_TASK:
      return {
        ...state,
    };
    case actions.GetTaskAction.TASK_RESPONSE:
          return{
      ...state,
      questionTaskData : action.data.TaskQuestionResponses,
      // userid: action.payload.user_ID,
      // projectid: action.payload.project_ID,
    };

    default:
      return state;
  }
};

export default reducer;
